import React from 'react'
import { Select as SelectControl, FormGroup, MenuItem, InputLabel, Box } from '@material-ui/core';

const Select = ({onChange, value, ...props}) => {
    return (
        <Box pt={3}>
            <FormGroup row>
                <InputLabel id="demo-simple-select-label">{props.label||''}</InputLabel>
                <SelectControl
                    key={`field_inner_${props.name}`}
                    name={props.name}                
                    onChange={ (ev) => onChange( ev.target.name, ev.target.value ) }
                    fullWidth
                    value={value}
                    {...props}
                >
                    { Object.entries(props.options||{}).map( (item) => (<MenuItem key={`field_inner_${props.name}_${item[0]}`} value={item[0]}>{item[1]}</MenuItem> )) }
                </SelectControl>
            </FormGroup>
        </Box>
    )
}

export default Select;